import { percentageFormatter, amountFormatter } from 'utils/formatters';
import { ru } from 'locale';

// eslint-disable-next-line import/prefer-default-export
export const columns = [
  { dataKey: 'years', label: '', width: 120 },
  { dataKey: 'revenue', label: ru.revenue, width: 120, formatter: amountFormatter },
  { dataKey: 'grossProfit', label: ru.grossProfitShort, width: 120, formatter: amountFormatter },
  { dataKey: 'markup', label: ru.markup, width: 100, formatter: percentageFormatter },
  { dataKey: 'payments', label: ru.payments, width: 120, formatter: amountFormatter },
  {
    dataKey: 'receivableEndOfPeriod',
    label: ru.receivableEndOfPeriodShort,
    width: 120,
    formatter: amountFormatter,
  },
  {
    dataKey: 'maxOverdueReceivable',
    label: ru.maxOverdueReceivableShort,
    width: 120,
    formatter: amountFormatter,
  },
  {
    dataKey: 'maxDaysPastDue',
    label: ru.maxDaysPastDueShort,
    width: 120,
    formatter: amountFormatter,
  },
  { dataKey: 'contractLimit', label: ru.limit, width: 120, formatter: amountFormatter },
];
